import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineTaskListEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="F8F7F6"
      fillRule="evenodd"
      d="M38.625 18.5C19.5 13 10.5 32.5 22.5 45.125H6.125a3.25 3.25 0 0 1-3.25-3.25V6.125a3.25 3.25 0 0 1 3.25-3.25H27.25L38.625 14.25z"
      clipRule="evenodd"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M38.625 18.5v-4.25L27.25 2.875H6.125a3.25 3.25 0 0 0-3.25 3.25v35.75a3.25 3.25 0 0 0 3.25 3.25H22.5"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.83 14.679 3.18 3.18 5.3-7.42M9.83 27.882l3.18 3.18 5.3-7.42"
    />
    <path
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M32.125 41.875c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m45.125 45.125-5.688-5.688"
    />
  </svg>
);
export default SvgStreamlineTaskListEdit;
